"use client";

import { ArrowRight, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const perks = [{
  label: "Certified industrial-grade waterproofing systems"
}, {
  label: "24/7 emergency leak response & structural repair"
}, {
  label: "Comprehensive 10-year workmanship guarantees"
}];
export default function DriveYourGrowth() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="231037" id="direct-support" className="dark relative min-h-screen w-full overflow-hidden flex items-center justify-start bg-background">
      {}
      <img src="https://rm-roofingandwaterproofing.com/wp-content/uploads/2026/04/roofing_blueprint_schematic-1.png" alt="" className="absolute inset-0 w-full h-full object-cover object-center" style={{
      zIndex: 0
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950/95 via-slate-900/80 to-slate-900/40" />

      {}
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: "var(--chart-1)"
    }} />
      <div className="absolute top-20 right-1/4 w-64 h-64 rounded-full opacity-10 blur-3xl pointer-events-none" style={{
      background: "var(--chart-3)"
    }} />

      {}
      <div ref={heroRef} className={`relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-24 md:py-32 transition-all duration-1000 ${heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-xl lg:max-w-2xl">
          {}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-8 border text-sm font-mono font-semibold tracking-wider uppercase" style={{
          background: "hsla(38, 92%, 50%, 0.12)",
          borderColor: "hsla(38, 92%, 50%, 0.4)",
          color: "var(--chart-3)"
        }}>
            <span className="w-2 h-2 rounded-full animate-pulse" style={{
            background: "var(--chart-3)"
          }} />
            Structural Integrity Guaranteed
          </div>

          {}
          <div ref={textRef} className={`transition-all duration-1000 delay-200 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight text-white mb-6 tracking-tighter" style={{
            textShadow: "0 4px 24px rgba(0,0,0,0.6)"
          }}>
              Built to Last,{" "}
              <br />
              <span style={{
              color: "var(--chart-3)"
            }}>Sealed to Protect,</span>
              <br />
              RM Roofing.
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-default mb-8 leading-relaxed max-w-lg">
              Premium roofing and waterproofing solutions for industrial and commercial assets. 
              Engineered for durability, installed with architectural precision.
            </p>

            {}
            <ul className="flex flex-col gap-3 mb-10">
              {perks.map((perk, i) => <li data-index={i} key={i} className={`flex items-center gap-3 text-white/90 font-default text-base transition-all duration-700`} style={{
              transitionDelay: `${300 + i * 100}ms`
            }}>
                  <CircleCheck className="w-5 h-5 shrink-0" style={{
                color: "var(--chart-3)"
              }} />
                  {perk.label}
                </li>)}
            </ul>

            {}
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
              <Button asChild size="lg" className="text-base font-default font-bold px-8 py-6 rounded-full shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl border-0" style={{
              background: "var(--chart-3)",
              color: "hsl(222, 47%, 6%)"
            }}>
                <Link to="#">
                  Request a Quote
                  <ArrowRight className="ml-1 w-5 h-5" />
                </Link>
              </Button>

              </div>
          </div>

          {}
          <div className={`mt-14 flex flex-wrap gap-8 transition-all duration-1000 delay-500 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {[{
            value: "15+",
            label: "Years Experience"
          }, {
            value: "100%",
            label: "Leak-Free Record"
          }, {
            value: "24/7",
            label: "Emergency Support"
          }].map((stat, i) => <div data-index={i} key={i} className="flex flex-col">
                <span className="font-mono text-2xl md:text-3xl font-bold" style={{
              color: "var(--chart-3)"
            }}>
                  {stat.value}
                </span>
                <span className="font-mono text-xs uppercase tracking-widest text-white/60 mt-0.5">
                  {stat.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px opacity-20" style={{
      background: "var(--chart-3)"
    }} />
    </section>;
}